module.exports = __webpack_public_path__ + "static/media/1_UAcfmRyCxepprYijDr3Mkg.0ce29560.jpeg";